import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
function SectionHeading({
  children
}: {
  children: React.ReactNode;
}) {
  return <h2 className="font-extrabold" style={{
    fontSize: 32,
    lineHeight: '44.8px',
    color: '#003366',
    maxWidth: 783,
    fontFamily: 'Figtree, sans-serif'
  }} data-id="element-18">
      {children}
    </h2>;
}
function BodyText({
  children
}: {
  children: React.ReactNode;
}) {
  return <div style={{
    fontSize: 18,
    lineHeight: '27px',
    color: '#16283B',
    maxWidth: 874,
    fontFamily: 'Figtree, sans-serif'
  }} data-id="element-19">
      {children}
    </div>;
}
function ArticleImage({
  src,
  alt,
  width,
  height
}: {
  src: string;
  alt: string;
  width?: number;
  height?: number;
}) {
  return <div className="flex justify-center w-full" data-id="element-20">
      <img src={src} alt={alt} className="object-cover w-full md:max-w-[70%] md:w-auto" style={{
      height: height ? height * 0.7 : 'auto'
    }} data-id="element-21" />
    </div>;
}
export function ArticleBody() {
  return <div className="flex flex-col" style={{
    gap: 27,
    fontFamily: 'Figtree, sans-serif'
  }} data-id="element-22">
      {/* Body text block 1 */}
      <BodyText data-id="element-23">
        <p data-id="element-24">Du stehst morgens im Bad.</p>

        <p className="mt-4" data-id="element-25">Wasser im Gesicht, Blick in den Spiegel…</p>

        <p className="mt-4" data-id="element-26">
          …und für eine Sekunde erkennst du dich nicht wieder.
        </p>

        <p className="mt-4" data-id="element-27">
          Da ist dieser müde Blick. Die tiefen Schatten unter den Augen. Falten,
          die vor zwei Jahren noch nicht da waren.
        </p>

        <p className="mt-4" data-id="element-28">
          <strong data-id="element-29">Du siehst das Gesicht deines Vaters.</strong>
        </p>

        <p className="mt-4" data-id="element-30">
          Auf der Arbeit fragt dich ein Kollege, ob du schlecht geschlafen hast.{' '}
          <strong data-id="element-31">Hast du nicht.</strong> So siehst du jetzt einfach aus.
        </p>

        <p className="mt-4" data-id="element-32">
          Deine Frau sagt nichts. Aber du merkst, dass{' '}
          <strong data-id="element-33">sie dich anders anschaut als früher.</strong>
        </p>

        <p className="mt-4" data-id="element-34">Und wenn du ehrlich bist…</p>

        <p className="mt-4" data-id="element-35">…kratzt das verdammt an deinem Ego.</p>

        <p className="mt-4" data-id="element-36">
          Aber du bist nicht allein.{' '}
          <strong data-id="element-37">
            9 von 10 Männern über 40 stören ihre Falten und Augenringe fast
            täglich.
          </strong>
        </p>

        <p className="mt-4" data-id="element-38">
          Doch die meisten reden nicht darüber – warum sollte sich ein Mann über
          seine Falten oder Augenringe beschweren?
        </p>

        <p className="mt-4" data-id="element-39">
          Also tust du nichts. Oder du probierst irgendeine Creme und hoffst,
          dass es besser wird…
        </p>
      </BodyText>

      {/* Heading 1 */}
      <SectionHeading data-id="element-40">
        Aber wenn es so viele Männer betrifft, warum gibt es dann keine
        anständige Lösung?
      </SectionHeading>

      {/* Scientist GIF/Image */}
      <img src="https://maleup.de/cdn/shop/files/Scientist.gif?v=1773410171&width=800" alt="" loading="lazy" className="rounded mt-6" data-id="element-41" />

      {/* Body text block 2 */}
      <BodyText data-id="element-42">
        <p data-id="element-43">
          Du hast wahrscheinlich schon mal eine Creme aus der Drogerie
          ausprobiert. Oder die deiner Frau benutzt.
        </p>

        <p className="mt-4" data-id="element-44">
          Drei Wochen lang, jeden Morgen. Und dann? Nichts. Kein Unterschied.
        </p>

        <p className="mt-4" data-id="element-45">
          An der Müdigkeit in deinem Gesicht hat sich rein gar nichts verändert.
        </p>

        <p className="mt-4" data-id="element-46">Doch daran bist du nicht Schuld…</p>

        <p className="mt-4" data-id="element-47">
          …und es liegt auch nicht daran, dass du bei der Creme die falsche
          Marke erwischt hast.
        </p>

        <p className="mt-4" data-id="element-48">
          Das Problem ist grundlegender:{' '}
          <strong data-id="element-49">Männerhaut ist bis zu 30% dicker als Frauenhaut.</strong> Sie
          produziert doppelt so viel Talg und hat eine völlig andere Struktur.
        </p>

        <p className="mt-4" data-id="element-50">
          Trotzdem verkaufen die großen Kosmetikkonzerne Männern seit
          Jahrzehnten dasselbe Produkt:{' '}
          <strong data-id="element-51">
            Sie nehmen ihre Frauenformel, kleben ein neues Etikett drauf, packen
            es in eine blaue Verpackung und verkaufen es dir als „für Männer
            entwickelt.”
          </strong>
        </p>

        <p className="mt-4" data-id="element-52">Aber das allein erklärt noch nicht alles…</p>

        <p className="mt-4" data-id="element-53">
          Denn selbst Cremes, die tatsächlich für Männer entwickelt wurden,
          scheitern – und zwar aus einem Grund, den die meisten Dermatologen
          ihren Patienten nicht erklären…
        </p>
      </BodyText>

      {/* Heading 2 */}
      <SectionHeading data-id="element-54">
        Was seit Jahrzehnten wirklich mit deiner Haut passiert, ohne dass du es
        merkst
      </SectionHeading>

      {/* Collagen comparison image */}
      <ArticleImage src="https://cdn.magicpatterns.com/patterns/figma-images/66g1a0V3VBLDEJqj7q2Lq0/4161-632.png" alt="Junge Haut Kollagen vs alte Haut Kollagen" data-id="element-55" />

      {/* Body text block 3 */}
      <BodyText data-id="element-56">
        <p data-id="element-57">
          Ab deinem 25. Lebensjahr verliert{' '}
          <strong data-id="element-58">deine Haut jedes Jahr rund 1% ihres Kollagens.</strong> (Also
          genau das, was deine Haut jung, straff und vital aussehen lässt)
        </p>

        <p className="mt-4" data-id="element-59">Das klingt wenig…</p>

        <p className="mt-4" data-id="element-60">
          Aber bis du 45 bist, sind das über 20%. Und bis du 55 bist, fast ein
          Drittel.
        </p>

        <p className="mt-4" data-id="element-61">
          Das Tückische daran:{' '}
          <strong data-id="element-62">
            Weil Männerhaut dicker ist als Frauenhaut, merkst du jahrelang
            nichts davon.
          </strong>{' '}
          Deine Haut hält die Fassade aufrecht, während sie darunter langsam an
          Substanz verliert.
        </p>

        <p className="mt-4" data-id="element-63">
          Selbst mit Ende 30 <em data-id="element-64">– vielleicht sogar mit Anfang 40 –</em> siehst
          noch gut aus. Also denkst du, alles ist in Ordnung.
        </p>

        <p className="mt-4" data-id="element-65">
          <strong data-id="element-66">
            Bis zu dem Tag, an dem es sich nicht mehr verstecken lässt.
          </strong>
        </p>

        <p className="mt-4" data-id="element-67">
          Auf einmal siehst du müde, eingefallen und alt aus.
        </p>

        <p className="mt-4" data-id="element-68">
          Und du fragst dich: Kannst ich das überhaupt noch rückgängig machen?
        </p>

        <p className="mt-4" data-id="element-69">
          <strong data-id="element-70">Die Antwort ist ja.</strong>
        </p>

        <p className="mt-4" data-id="element-71">
          Aber nur, wenn du verstehst, wo genau dein Kollagen verloren geht —
          und warum 99% aller Produkte es dort niemals wieder aufbauen können…
        </p>
      </BodyText>

      {/* Heading 3 */}
      <SectionHeading data-id="element-72">Der wahre Grund für deine tiefen Falten</SectionHeading>

      <img src="https://maleup.de/cdn/shop/files/liquid_can_t_penetrate_skin_lab.gif?v=1773410830&width=240" alt="" loading="lazy" className="rounded mt-6" data-id="element-73" />

      {/* Body text block 4 */}
      <BodyText data-id="element-74">
        <p data-id="element-75">Deine Haut besteht aus zwei Schichten, die entscheidend sind.</p>

        <p className="mt-4" data-id="element-76">
          <strong data-id="element-77">Der Epidermis</strong> – die Oberfläche. Die Schicht, die du
          siehst und berühren kannst.
        </p>

        <p className="mt-4" data-id="element-78">
          <strong data-id="element-79">Und der Dermis</strong> – die Schicht darunter. Dort wird die
          Feuchtigkeit gespeichert und das Kollagen produziert.
        </p>

        <p className="mt-4" data-id="element-80">Aber genau hier scheitern fast alle Cremes.</p>

        <p className="mt-4" data-id="element-81">
          Die Moleküle in herkömmlichen Produkten – egal ob Hyaluron, Aloe Vera
          oder Vitamin C – sind schlichtweg{' '}
          <strong data-id="element-82">zu groß, um durch die Epidermis zu gelangen.</strong>
        </p>

        <p className="mt-4" data-id="element-83">
          Stell dir vor, du versuchst einen Fußball durch ein Schlüsselloch zu
          drücken. Das funktioniert nicht.
        </p>

        <p className="mt-4" data-id="element-84">
          Das ist der Grund, warum du nach jeder Creme dachtest: „Funktioniert
          nicht."
        </p>

        <p className="mt-4" data-id="element-85">
          Es war nicht die falsche Marke. Es war nicht deine Schuld.
        </p>

        <p className="mt-4" data-id="element-86">
          Die Wirkstoffe sind physikalisch nie dort angekommen, wo deine Haut
          sie braucht.
        </p>
      </BodyText>

      {/* Heading 4 */}
      <SectionHeading data-id="element-87">
        Was ist mit Botox, Fillern oder Schönheits-OPs?
      </SectionHeading>

      <img src="https://maleup.de/cdn/shop/files/Other_solutions_men_skincare.png?v=1773410894&width=500" alt="" loading="lazy" className="rounded mt-6" data-id="element-88" />

      {/* Body text block 5 */}
      <BodyText data-id="element-89">
        <p data-id="element-90">Manche Männer denken an diesem Punkt: Dann eben Botox.</p>

        <p className="mt-4" data-id="element-91">
          Aber das Problem mit invasiven Eingriffen ist, dass sie ausschließlich
          die Symptome behandeln.
        </p>

        <ul className="mt-4 list-disc pl-5" data-id="element-92">
          <li data-id="element-93">
            Botox{' '}
            <strong data-id="element-94">
              lähmt die Muskeln unter der Haut, wodurch sich die Falten temporär
              glätten. Aber sobald die Wirkung nach 3-4 Monaten nachlässt, sind
              die Falten zurück.
            </strong>
          </li>
          <li className="mt-2" data-id="element-95">
            Filler können verrutschen und sich in sichtbare Knötchen verwandeln.
          </li>
          <li className="mt-2" data-id="element-96">
            Sich unters Messer zu legen ist nicht nur teuer, sondern auch kaum
            rückgängig zu machen, wenn dir das Ergebnis nicht gefällt.
          </li>
        </ul>

        <p className="mt-4" data-id="element-97">
          Hinzukommt, dass bei all diesen „Lösungen” das eigentlich Problem
          bestehen bleibt…
        </p>

        <p className="mt-4" data-id="element-98">
          <strong data-id="element-99">
            Denn deine Dermis bleibt ausgetrocknet und das Kollagen fehlt
            weiterhin.
          </strong>
        </p>

        <p className="mt-4" data-id="element-100">
          Für 70-80 jährige Männer mit jahrzehntealten, extrem tiefen Falten
          kann ein Eingriff eine Überlegung wert sein.
        </p>

        <p className="mt-4" data-id="element-101">
          Aber für die meisten Männer ab 40, bei denen die Falten und Augenringe
          in den letzten Jahren dazugekommen sind, ergibt das keinen Sinn.
        </p>

        <p className="mt-4" data-id="element-102">
          Nicht bei diesen Kosten, diesen Risiken und nicht, wenn die
          eigentliche Ursache unbehandelt bleibt…
        </p>
      </BodyText>

      {/* CTA Button 2 */}

      {/* Heading 5 */}
      <SectionHeading data-id="element-103">
        Was nicht funktioniert – welche Möglichkeit bleibt dir?
      </SectionHeading>

      <img src="https://maleup.de/cdn/shop/files/man_looking_in_mirror.gif?v=1773411056&width=480" alt="" loading="lazy" className="rounded mt-6" data-id="element-104" />

      {/* Body text block 6 */}
      <BodyText data-id="element-105">
        <p data-id="element-106">
          Die Wahrheit ist:{' '}
          <strong data-id="element-107">
            Den biologischen Alterungsprozess selbst kannst du nicht aufhalten.
          </strong>
        </p>

        <p className="mt-4" data-id="element-108">
          Aber den sichtbaren Schaden kannst du reparieren.{' '}
          <strong data-id="element-109">Wenn du jetzt handelst.</strong>
        </p>

        <p className="mt-4" data-id="element-110">
          Denn deine Dermis verliert jeden Tag weiter an Feuchtigkeit und
          Kollagen.
        </p>

        <p className="mt-4" data-id="element-111">
          Ab einem bestimmten Punkt wird dieser Schaden irreversibel.
        </p>

        <p className="mt-4" data-id="element-112">
          Jeder Tag, an dem du nichts tust, bringt dich einen Tag näher an den
          Punkt, an dem der Schaden nicht mehr umkehrbar ist.
        </p>

        <p className="mt-4" data-id="element-113">
          Für Männer zwischen 40 und 60, bei denen die sichtbare Hautalterung
          erst in den letzten Jahren eingesetzt hat, gibt es jetzt ein
          Zeitfenster.
        </p>

        <p className="mt-4" data-id="element-114">
          Und genau dieses Zeitfenster hat ein kleines deutsches Startup namens
          MaleUp versucht zu nutzen.
        </p>

        <p className="mt-4" data-id="element-115">
          Nach über drei Jahren Entwicklung speziell für Männerhaut haben sie
          etwas gefunden, das funktioniert…
        </p>
      </BodyText>

      {/* Heading 6 */}
      <SectionHeading data-id="element-116">Was genau ist die MaleUp Face Cream?</SectionHeading>

      <div className="mt-6 flex" data-id="element-117">
        <img src="https://maleup.de/cdn/shop/files/Maleup_ingredients_graphic.png?v=1773413114&width=1200" alt="" loading="lazy" className="w-full max-w-[700px]" data-id="element-118" />
      </div>

      <BodyText data-id="element-119">
        <p data-id="element-120">
          MaleUp wurde mit dem Ziel entwickelt, diese Lösung so vielen Männern
          wie möglich zugänglich zu machen.
        </p>

        <p className="mt-4" data-id="element-121">Zum Vergleich:</p>

        <ul className="mt-4 list-disc pl-5" data-id="element-122">
          <li data-id="element-123">
            Eine Botox-Behandlung kostet 300 bis 600 Euro pro Sitzung – mehrmals
            im Jahr.
          </li>
          <li className="mt-2" data-id="element-124">
            Premium-Seren liegen bei 50 bis 120 Euro pro Flasche. Ohne messbare
            Ergebnisse.
          </li>
        </ul>

        <p className="mt-4" data-id="element-125">
          Die MaleUp Face Cream kostet im{' '}
          <strong data-id="element-126">Einzelkauf unter 40 Euro.</strong>
        </p>

        <p className="mt-4" data-id="element-127">
          Bei 1,30 Euro pro Anwendung ist das weniger als dein Kaffee am Morgen.
        </p>

        <p className="mt-4" data-id="element-128">
          Aber es gibt aktuell ein spezielles Angebot, nur für Leser dieses
          Artikels, das den Preis noch deutlich senkt…
        </p>
      </BodyText>

      {/* Heading 7 (repeated) */}
      <SectionHeading data-id="element-129">
        Wie bekommst du die MaleUp Face Cream zum besten Preis??
      </SectionHeading>

      {/* 30-day guarantee image */}
      <ArticleImage src="https://cdn.magicpatterns.com/uploads/uBK1YFbXvD7dhdAuuBY1M3/30_Rabatt_(6).jpg" alt="MaleUp 3x Anti-Aging Face Cream + GRATIS Augenserum – Du sparst insgesamt 60€" data-id="element-130" />

      {/* Body text block 7 */}
      <BodyText data-id="element-131">
        <p data-id="element-132">
          Für die Leser auf dieser Seite gibt es aktuell ein exklusives Angebot,
          das so nicht im normalen Shop verfügbar ist:
        </p>
        <p className="mt-4" data-id="element-133">
          <a href="https://maleup.de/products/quiz-deal-3x-anti-aging-face-cream?variant=52835646537995" target="_blank" rel="noopener noreferrer" className="underline" style={{
          color: '#16283B'
        }} data-id="element-134">
            Das 3er Bundle der MaleUp Face Cream mit bis zu 60€ Rabatt (+
            kostenloses Geschenk)
          </a>
        </p>
        <p className="mt-4" data-id="element-135">
          <strong data-id="element-136">Warum ausgerechnet das 3er-Bundle?</strong>
        </p>
        <p className="mt-4" data-id="element-137">
          Weil die besten Ergebnisse nach 8–12 Wochen regelmäßiger Anwendung
          sichtbar werden. Eine Flasche reicht für etwa 4 Wochen. Mit drei
          Flaschen hast du genug, um den vollen Effekt zu erleben – und sparst
          dabei bis zu 30€ gegenüber dem Einzelkauf.
        </p>
      </BodyText>

      {/* CTA Button 3 */}
      <CTAButton data-id="element-138" />

      {/* Heading 8 */}
      <SectionHeading data-id="element-139">
        Kein Fettfilm. Keine Rückstände. Keine 10-Schritte-Routine.
      </SectionHeading>

      <div className="mt-6 flex" data-id="element-140">
        <img src="https://maleup.de/cdn/shop/files/Maleup_ingredients_graphic.png?v=1773413114&width=1200" alt="" width={1200} height={1200} loading="lazy" className="w-full max-w-[700px]" data-id="element-141" />
      </div>
      {/* Body text block 8 */}
      <BodyText data-id="element-142">
        <p data-id="element-143">
          Die MaleUp Face Cream wurde für Männer entwickelt, die keine Zeit für
          komplizierte Routinen haben.
        </p>
        <p className="mt-4" data-id="element-144">
          Du trägst sie morgens auf. 30 Sekunden einziehen lassen - das war's!
        </p>
        <p className="mt-4" data-id="element-145">❌ Kein öliger Film auf der Haut</p>
        <p data-id="element-146">❌ Kein unangenehmer Geruch</p>
        <p data-id="element-147">❌ Keine klebrigen Rückstände</p>
      </BodyText>

      {/* CTA Button 3 */}
      <CTAButton data-id="element-148" />

      {/* Heading 9 */}
      <SectionHeading data-id="element-149">
        Du hast 30 Tage, um die MaleUp Face Cream risikofrei zu testen.
      </SectionHeading>

      {/* Product lifestyle image */}
      <ArticleImage src="https://cdn.magicpatterns.com/patterns/figma-images/66g1a0V3VBLDEJqj7q2Lq0/4161-167.png" alt="MaleUp Face Cream Produkt" data-id="element-150" />

      {/* Body text block 10 */}
      <BodyText data-id="element-151">
        <p data-id="element-152">Ein gutes Produkt braucht kein Kleingedrucktes.</p>
        <p className="mt-4" data-id="element-153">
          Deshalb ist jede Bestellung durch eine vollständige
          30-Tage-Geld-zurück-Garantie abgesichert.
        </p>
        <p className="mt-4" data-id="element-154">
          Teste die MaleUp Face Cream in deinem Alltag. Trag sie jeden Morgen
          auf. Und wenn du nach 30 Tagen nicht überzeugt bist – bekommst du dein
          Geld zurück. Ohne Fragen. Ohne Bedingungen.
        </p>
      </BodyText>

      {/* CTA Button 4 */}
      <CTAButton data-id="element-155" />

      {/* Heading 10 */}
      <SectionHeading data-id="element-156">Denk daran, warum das wichtig ist.</SectionHeading>

      {/* Body text block 11 */}
      <BodyText data-id="element-157">
        <p data-id="element-158">Es geht nicht nur darum, einfach ein frischeres Gesicht zu haben.</p>
        <p className="mt-4" data-id="element-159">
          Es geht darum, wieder wahrgenommen zu werden. Von Frauen. Von
          Kollegen. Von deiner Partnerin.
        </p>
        <p className="mt-4" data-id="element-160">
          Es geht darum, morgens in den Spiegel zu schauen und zu denken: „Ja,
          so will ich aussehen."
        </p>
        <p className="mt-4" data-id="element-161">
          Es geht darum, die Kontrolle zurückzugewinnen – über dein Aussehen,
          dein Auftreten, dein Selbstbewusstsein.
        </p>
        <p className="mt-4" data-id="element-162">
          Die MaleUp Face Cream gibt dir diese Möglichkeit. Ohne Risiko. Ohne
          Aufwand. Ohne Kompromisse.
        </p>
      </BodyText>
    </div>;
}